export default function compileReducers(reducers, initialState = {}) {
  return (state = initialState, action) => {
    if (reducers[action.type]) {
      return reducers[action.type](state, action.payload);
    }

    return state;
  };
}
